import { createMutationHook } from '~/shared/providers/api';

type SignInInput = {
  clientId: string;
  email: string;
  password: string;
};

export const useSignIn = createMutationHook(
  'authentication.signIn',
  ({ clientId, email, password }: SignInInput) => ({
    authenticationSignIn: {
      __args: {
        clientId,
        email,
        password,
      },
      __typename: true,
      on_EmailVerificationRequiredError: {
        pendingAuthenticationToken: true,
      },
      on_MfaEnrollmentRequiredError: {
        pendingAuthenticationToken: true,
      },
      on_MfaChallengeError: {
        pendingAuthenticationToken: true,
        authenticationFactors: {
          __scalar: true,
        },
      },
      on_OrganizationSelectionError: {
        pendingAuthenticationToken: true,
        organizations: {
          id: true,
          name: true,
        },
      },
      on_AuthenticationResponse: {
        accessToken: true,
        user: {
          id: true,
          firstName: true,
          lastName: true,
          email: true,
        },
        organization: {
          id: true,
          name: true,
          domain: true,
          entitlements: true,
        },
      },
    },
  }),
);
